import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// Youtube/Vimeo popups
Fancybox.bind('[data-popup-youtube], [data-popup-vimeo]', {
	on: {
		'Carousel.ready': (fancyboxRef) => {
			const fancybox = fancyboxRef.getOptions();
			const fancyboxContainer = fancyboxRef.getContainer()?.querySelector('.f-html');
			const containerSection = fancybox.triggerEl.closest('section');

			if (containerSection) {
				const transcription = containerSection.querySelector('[data-video-transcription]');
				if (transcription) {
					if (!fancyboxContainer.querySelector('[data-video-transcription]')) {
						const transcriptionClone = transcription.cloneNode(true);
						transcriptionClone.classList.remove('hidden');
						transcriptionClone.classList.add('absolute', 'w-full', 'top-full', 'left-0');
						fancyboxContainer.classList.add('relative');
						fancyboxContainer.append(transcriptionClone);
					}
				}
			}

			fancyboxContainer.querySelector('.is-close-button').focus();
			fancyboxContainer.querySelector('iframe').setAttribute('title', 'Play Video');
		},
	},
});

// Default WP Gallery popups
Fancybox.bind('.popup-gallery', {
	Thumbs: { type: 'classic' },
	on: {
		'Carousel.ready': (fancyboxRef) => {
			const toolbar = fancyboxRef.getContainer()?.querySelector('.f-carousel__toolbar');
			toolbar.querySelector('[data-fancybox-close]')?.focus();
		},
	},
});

/**
 * Open a DOM element as a Fancybox inline popup. The element is moved into the
 * lightbox while open, so any live DOM updates (e.g. AJAX) are reflected immediately.
 *
 * @param {HTMLElement} el    The element to show (must have an id).
 * @param {object}      opts  Extra Fancybox options (merged with defaults).
 * @return {Fancybox}
 */
export function openHtmlPopup(el, opts = {}) {
	el.style.display = '';

	return Fancybox.show(
		[{ src: '#' + el.id, type: 'inline' }],
		Object.assign(
			{
				mainClass: 'whitepaper-popup',
				closeButton: 'top',
				autoFocus: false,
				dragToClose: false,
				on: {
					reveal: (instance) => {
						const close = instance.getContainer()?.querySelector('[data-fancybox-close]');
						if (close) close.focus();
					},
				},
			},
			opts
		)
	);
}
